// This has to be a js file for gatsby-config to import it.

const supportedLanguages = ["en", "da", "no", "is", "sv", "de", "nl", "fr"]
const supportedLanguagesLabels = new Map([
  ["en", "English"],
  ["da", "Dansk"],
  ["no", "Norsk"],
  ["is", "íslenskur"],
  ["sv", "Svenska"],
  ["de", "Deutsch"],
  ["nl", "Nederlands"],
  ["fr", "Français"],
])

const supportedLanguagesEmojies = new Map([
  ["en", "🇬🇧"],
  ["da", "🇩🇰"],
  ["no", "🇳🇴"],
  ["is", "🇮🇸"],
  ["sv", "🇸🇪"],
  ["de", "🇩🇪"],
  ["nl", "🇳🇱"],
  ["fr", "🇫🇷"],
])

module.exports = {
  supportedLanguages,
  supportedLanguagesLabels,
  supportedLanguagesEmojies,
}
